var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8011 10.0005C22.2578 12.2418 21.9323 14.5719 20.879 16.6023C19.8256 18.6326 18.108 20.2405 16.0126 21.1578C13.9172 22.0751 11.5707 22.2463 9.3644 21.6428C7.15807 21.0394 5.22529 19.6979 3.88838 17.8419C2.55146 15.9859 1.89122 13.7277 2.01776 11.4439C2.14431 9.16001 3.04998 6.98857 4.58375 5.29165C6.11752 3.59473 8.18668 2.47491 10.4462 2.11893C12.7056 1.76295 15.0189 2.19234 17.0001 3.33548",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 11L12 14L22 4",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/check-circle.5384db26839482d2c404e87e1d03bc9c.svg";
export { ForwardRef as ReactComponent };